import { useEffect, useState } from "react";
import {
  MaterialReactTable,
  createMRTColumnHelper,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Link,
  ThemeProvider,
  Tooltip,
  createTheme,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";

// import { NotificationIcon } from "react-autoql";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const CustomTable2 = ({
  columns,
  data,
  showRowAction = false,
  DataForExportAll,
  loading = false,
  permissionKey,
}) => {
  if (!data) {
    data = [];
  }
  if (!DataForExportAll) {
    DataForExportAll = data;
  }

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);

  const canExport = rolePermissions?.[permissionKey]?.export === 1;

  //-------------------$$----------------------------------

  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  const handleExportData = () => {
    const specificData = DataForExportAll.map((item) => ({
      id: item._id, // Mapping the '_id' field
      registerType: item.registerType, // Mapping the 'registerType' field
      accHolderName: item.accHoldername, // Mapping the 'accHoldername' field
      accNo: item.accNo, // Mapping the 'accNo' field
      ifscCode: item.Ifsccode, // Mapping the 'Ifsccode' field
      "address/companyAddress":
        item.registerType == "entity" ? item.companyAddress : item.Address, // Mapping the 'Address' field
      "name/entityname":
        item.registerType == "entity" ? item.Entityname : item.name, // Mapping the 'name' field
      aadharNo: item.aadharNo, // Mapping the 'aadharNo' field
      "email/entityEmail":
        item.registerType == "entity" ? item.Entityemail : item.email, // Mapping the 'email' field
      dob: item.dob, // Mapping the 'dob' field
      panNo: item.panNo, // Mapping the 'panNo' field
      userName: item.userName, // Mapping the 'userName' field
      city: item.city, // Mapping the 'city' field
      state: item.state, // Mapping the 'state' field
      mobileNo: item.mobileNo, // Mapping the 'mobileNo' field
      pincode: item.pincode, // Mapping the 'pincode' field
      isDeleted: item.is_deleted === 1 ? true : false, // Mapping 'is_deleted' field
      commissionPercentage: item.commission_per, // Mapping the 'commission_per' field
      mmtc_commissionPercentage: item.mmtc_commission_per, // Mapping the 'commission_per' field
      status: item.isBlocked ? "Blocked" : "Active", // Mapping 'isBlocked' to 'status'
      flag: item.flag, // Mapping the 'flag' field
      createdAt: item.createdAt, // Mapping the 'createdAt' field
      updatedAt: item.updatedAt, // Mapping the 'updatedAt' field
      token: item.token, // Mapping the 'token' field
      entityType: item.EntityType || null, // Mapping the 'EntityType' field for entities
      //   entityName: item.Entityname || null, // Mapping the 'Entityname' field for entities
      //   entityIdentificationNo: item.EntityidentificationNo || null, // Mapping the 'EntityidentificationNo'
      //   entityEmail: item.Entityemail || null, // Mapping the 'Entityemail'
      //   authorizedPersonName: item.authpersonName || null, // Mapping the 'authpersonName'
      //   companyAddress: item.companyAddress || null, // Mapping the 'companyAddress'
      //   gstin: item.Gstin || null, // Mapping the 'Gstin'
    }));

    // const csv = generateCsv(csvConfig)(data);
    const csv = generateCsv(csvConfig)(specificData);
    download(csvConfig)(csv);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading, // <--- Use this built-in prop for loading state
    },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    // enableRowActions: true,
    enableRowActions: showRowAction,
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    maxSize: 100,

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#DCDAFF",
        fontWeight: "normal",
      }),
    },

    renderRowActions: ({ cell, row, table }) => [
      <>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Tooltip title="Edit User">
            <IconButton>
              {/* <IconButton onClick={() => handleOpen(row.original)}> */}
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton>
              {/* <IconButton onClick={() => handleBlockUser(row.original)}> */}
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      </>,
    ],
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}
        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}
      </Box>
    ),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    // <ThemeProvider theme={darkTheme}>
    <MaterialReactTable table={table} />
    // </ThemeProvider>
  );
};

export default CustomTable2;
